import { useState, useEffect } from 'react';
import type { TypingWord } from '@/lib/content';

interface TypingTextProps {
  words: TypingWord[];
}

export const TypingText = ({ words }: TypingTextProps) => {
  const [wordIndex, setWordIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isPaused, setIsPaused] = useState(false);

  const typingSpeed = 100;
  const deletingSpeed = 50;
  const pauseDuration = 1500;

  useEffect(() => {
    const currentWord = words[wordIndex];
    let timeout: NodeJS.Timeout;

    if (isPaused) {
      timeout = setTimeout(() => {
        setIsPaused(false);
        setIsDeleting(true);
      }, pauseDuration);
    } else if (!isDeleting) {
      if (charIndex < currentWord.text.length) {
        timeout = setTimeout(() => {
          setCharIndex(charIndex + 1);
        }, typingSpeed);
      } else {
        setIsPaused(true);
      }
    } else {
      if (charIndex > 0) {
        timeout = setTimeout(() => {
          setCharIndex(charIndex - 1);
        }, deletingSpeed);
      } else {
        setIsDeleting(false);
        setWordIndex((wordIndex + 1) % words.length);
      }
    }

    return () => clearTimeout(timeout);
  }, [charIndex, isDeleting, isPaused, wordIndex, words]);

  const currentWord = words[wordIndex];
  const displayText = currentWord.text.substring(0, charIndex);

  return (
    <span style={{ whiteSpace: 'nowrap' }}>
      <span style={{ color: currentWord.color }}>
        {displayText}
      </span>
      <span 
        className="inline-block w-0.5 h-[1em] ml-1 animate-pulse"
        style={{ 
          backgroundColor: currentWord.color,
          verticalAlign: 'text-bottom'
        }}
      />
    </span>
  );
};
